import React from 'react';
import Banners from '../../Components/Banners/Banners';
import Tiendas from '../../Components/Tiendas/Tiendas';
import './Demo.css';
import Footer from '../../Components/Footer/Footer';
import BtnWhatsapp from '../../Components/BtnWhatsapp/BtnWhatsapp';
import Cart from '../../Components/Cart/Cart';
import TiendaSocial from '../../Components/TiendaSocial/TiendaSocial';
import BannersTiendas from '../../Components/BannersTiendas/BannersTiendas';
import PasosTienda from '../../Components/PasosTienda/PasosTienda';
import GaleriaHome from '../../Components/GaleriaHome/GaleriaHome';

export default function Demo() {
    return (
        <section className='demo'>
            <Banners />
            <BannersTiendas />
            <Tiendas />
            <TiendaSocial />
            <PasosTienda />
            <GaleriaHome />
            <Footer />
            <BtnWhatsapp />
            <Cart />
        </section>
    )
      /*
         <developer />
      */
}
